import axios from "../../../../../../../api/axiosInstance";
import { FetchEventNotificationsResponse } from "./types";

export const fetchEventNotifications =
  async (): Promise<FetchEventNotificationsResponse> => {
    const response = await axios.get<FetchEventNotificationsResponse>(
      `/api/private/administration/events/notifications`,
    );

    return response.data;
  };
